import { monitor } from '@soluto-private/mx-monitor';

import {
  type LoggerReport,
  type LoggerReporter,
} from '@service-initiation/shared-clients-logger';

import { loggerSeverityToOspSeverity } from './utils';

export const ospReporter: LoggerReporter = {
  process: (report: LoggerReport) => {
    const ospSeverity = loggerSeverityToOspSeverity(report.severity);
    const extraData = {
      context: report.context,
      metadata: report.metadata,
    };

    if (ospSeverity === 'info') {
      monitor.info(
        report.message instanceof Error
          ? report.message.message
          : report.message,
        {
          extraData,
        }
      );
    } else {
      const error =
        report.message instanceof Error
          ? report.message
          : new Error(report.message);

      monitor[ospSeverity](error.message, error, {
        extraData,
      });
    }
  },
};
